import { createStoreChunk } from '@core/store'

// Gates the once-per-browser first-like dialog.

type TLikeState = { hasLikedBefore: boolean }

export const likeStore = createStoreChunk<TLikeState>('like')({
    persist: { localStorage: ['hasLikedBefore'] },
    initialState: { hasLikedBefore: false },
    actions: {
        markLikedBefore: () => ({ hasLikedBefore: true }),
    },
})
